export const siKinds = [
  'O-Original S/I',
  'A-Amendment S/I',
  'B-B/L Confirm',
  'M-Combine',
  'S-Split',
  'K-Return Back from Customer',
  'T-Attachment',
  'G-DG Attachment',
  'P-EL Attachment',
];

export const frontendDefaultSiKind = siKinds[0];
